import { render, staticRenderFns } from "./guias.vue?vue&type=template&id=42ba6d54&"
import script from "./guias.vue?vue&type=script&lang=js&"
export * from "./guias.vue?vue&type=script&lang=js&"
import style0 from "./guias.vue?vue&type=style&index=0&id=42ba6d54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports